import * as React from "react"
import {Box} from "@mui/material"
import {TooltipSeeker} from "@ui-seeker/core"
import {formatNumber, formatPercentage, isEmpty} from "@ui-seeker/utils"

import {BadgeVariant} from "@components";
import {ErrorInfoCell, WrapperBlock} from "../../../@components";


export const DataCell = ({ siteID, rowPrices, date, metric, haveMainPrice, filledData=false, showVariants=false }) => {

    const { currency, prices={}, isMain } = rowPrices[siteID] || {}
    const { price, color, evol, firstMoverDate, status, UnderPrice, stock, numVariantsInStock } = prices[date] || {}

    if (!filledData && isEmpty(prices)) return <></>
    if (filledData && isEmpty(prices)) return <ErrorInfoCell status="na" />

    if (!!status) return <ErrorInfoCell status={status} />

    if (!price) return <ErrorInfoCell status="na" />

    return <WrapperBlock color={color} firstMoverDate={firstMoverDate} metric={metric}>
        <Box display="flex" flexDirection='column' justifyContent="center">
            <Box
                display="flex"
                flexDirection='row-reverse'
                ml={2}
                color={isMain
                    ? "info.main"
                    : UnderPrice && !!haveMainPrice ? "error.main" : 'text.primary'
                }
                alignItems="center"
                gap={.5}
            >
                <TooltipSeeker title={stock ? "In Stock" : "Out of Stock"}>
                    <Box
                        width={10}
                        height={10}
                        borderRadius="50%"
                        border="1px solid #ccc"
                        backgroundColor={stock ? "success.main" : "error.main"}
                    />
                </TooltipSeeker>
                <TooltipSeeker title={!isMain ? `${evol > 0 ? '+' : ''}${formatPercentage(evol)}` : null}>
                    <Box>
                        {formatNumber(price, { decimals: 2 })}
                    </Box>
                </TooltipSeeker>
                { showVariants && !!numVariantsInStock &&
                    <Box component="span" mr={2} display="inline-flex">
                        <BadgeVariant numVariants={numVariantsInStock} tooltip="Variants in stock" />
                    </Box>
                }
            </Box>
        </Box>
    </WrapperBlock>
}
